<section class="results-pane-value item-section override-item-as-row">
  <span class="titles">Aberration Details</span>
  <div class="aberration-details" [ngClass]="verticalForm?'vertical-form':'horizontal-form'">
    <gen-dynamic-form *ngIf="aberrationDetailsFormName"
      [listenToDataChange]="true"
      [formData]="formData"
      [formName]="aberrationDetailsFormName"
      [formVertical]="verticalForm"
      [updateOnBlur]="false"
      [updatedFieldsContext]="updatedFieldsContext"
      [submitted]="submitted"
      [editMode]="!((inlineEdit || addNewMode) && !readOnly)"
      (formChange)="updateForm($event.form, $event.updated)"
      [disabled]="readOnly"
	  (validateChange)="validationEvent($event)"
      (linkClick)="linkClicked($event)"

      [requiredMessage]="''"
    >
        <ng-container *ngTemplateOutlet="tableList" container-content content-type="dataTable"></ng-container>
    </gen-dynamic-form>
  </div>

  <ng-template #tableList>
    <div *ngIf="showTable" class="table-container">
      <table>
        <thead>
          <tr>
            <th *ngFor="let head of tableHeadElements">{{head}} </th>
          </tr>
        </thead>
        <tbody>
          <tr *ngFor="let el of curationItem?.curationData?.variantTranslation?.data">
            <td>{{el.codingChange}}</td>
            <td>{{el.codingTranscript}}</td>
            <td>{{el.proteinChange}}</td>
            <td>{{el.proteinIdentifier}}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </ng-template>
</section>
